// extracted by mini-css-extract-plugin
module.exports = {"links_box":"mylinks_links_box__2FISX","linkedin_logo":"mylinks_linkedin_logo__3kHT0"};